import { PageRoutes } from '@/app/components/router/routes';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook to determine whether to show debtor portal components
 * based on the current route path.
 *
 * @returns {boolean} - Returns true if debtor portal components should be shown,
 * false if on billing reminder page
 */
export const useShowDebtorPortalComponents = (): boolean => {
  const location = useLocation();

  return (
    location.pathname === PageRoutes.DASHBOARD ||
    location.pathname === PageRoutes.ACCESS_DENIED // Allow user to sign out
  );
};
